import { useSigningAccess } from "@/domains/signing/useSigningAccess";
import { usePermissions } from "@/hooks/usePermissions";
import { useState } from "react";

import type { documentTableOptions } from "./documentTableOptions";
type Options = Pick<ReturnType<typeof documentTableOptions>, "enableSigning">;
export function useTableSigningState(options: Options) {
  const { enableSigning } = options;
  // Digital signing (Dokobit Documents Gateway) — opt-in via `enableSigning`,
  // gated on the org flag. Self-contained here so the shared bulk bar offers it
  // in every view (main docs, project docs, …) without per-parent wiring.
  // Drawing Compare's gate is develop's — it replaced the old `canUseIfcDiff`.
  const { canViewDrawingCompareTool } = usePermissions();
  // View opts in (enableSigning) AND the shared signing gate. `useSigningAccess`
  // is develop's expression verbatim (platform admin always | org rollout flag +
  // ALLOW_SIGNING), extracted so this table and the documents bulk bar cannot
  // drift apart on who may sign.
  const canSign = useSigningAccess();
  const signingEnabled = enableSigning === true && canSign;
  const [isSignDialogOpen, setIsSignDialogOpen] = useState(false);
  // Set when the signature panel asks to sign one specific container, which is
  // not necessarily the current selection (the panel can be open over a row the
  // user never ticked). Cleared when the dialog closes.
  const [signTarget, setSignTarget] = useState<{
    id: number;
    filename: string;
    size: number;
  } | null>(null);
  const [selectedDocumentsForSigning, setSelectedDocumentsForSigning] = useState<
    Array<{ id: number; filename: string; size: number }>
  >([]);
  return {
    setSelectedDocumentsForSigning,
    setIsSignDialogOpen,
    canViewDrawingCompareTool,
    signingEnabled,
    setSignTarget,
    isSignDialogOpen,
    signTarget,
    selectedDocumentsForSigning,
  };
}
